module.exports = __webpack_public_path__ + "static/blog-splash-2-b0fd4bb695873ca0facbbc2bc5652d55.jpg";